import clsx from 'clsx';

type TagProps = {
  children: React.ReactNode;
  className?: string;
  color?:
    | 'slate'
    | 'gray'
    | 'zinc'
    | 'neutral'
    | 'stone'
    | 'red'
    | 'orange'
    | 'amber'
    | 'yellow'
    | 'lime'
    | 'green'
    | 'emerald'
    | 'teal'
    | 'cyan'
    | 'sky'
    | 'blue'
    | 'indigo'
    | 'violet'
    | 'purple'
    | 'fuchsia'
    | 'pink'
    | 'rose';
};

export default function Tag({children, className, color = 'purple'}: TagProps) {
  const getColorClasses = (color: string) => {
    return (
      {
        slate:
          'bg-slate-100 dark:bg-slate-900/30 text-slate-600 dark:text-slate-300',
        gray: 'bg-gray-100 dark:bg-gray-900/30 text-gray-600 dark:text-gray-300',
        zinc: 'bg-zinc-100 dark:bg-zinc-900/30 text-zinc-600 dark:text-zinc-300',
        neutral:
          'bg-neutral-100 dark:bg-neutral-900/30 text-neutral-600 dark:text-neutral-300',
        stone:
          'bg-stone-100 dark:bg-stone-900/30 text-stone-600 dark:text-stone-300',
        red: 'bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-300',
        orange:
          'bg-orange-100 dark:bg-orange-900/30 text-orange-600 dark:text-orange-300',
        amber:
          'bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-300',
        yellow:
          'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-600 dark:text-yellow-300',
        lime: 'bg-lime-100 dark:bg-lime-900/30 text-lime-600 dark:text-lime-300',
        green:
          'bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-300',
        emerald:
          'bg-emerald-100 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-300',
        teal: 'bg-teal-100 dark:bg-teal-900/30 text-teal-600 dark:text-teal-300',
        cyan: 'bg-cyan-100 dark:bg-cyan-900/30 text-cyan-600 dark:text-cyan-300',
        sky: 'bg-sky-100 dark:bg-sky-900/30 text-sky-600 dark:text-sky-300',
        blue: 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-300',
        indigo:
          'bg-indigo-100 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-300',
        violet:
          'bg-violet-100 dark:bg-violet-900/30 text-violet-600 dark:text-violet-300',
        purple:
          'bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-300',
        fuchsia:
          'bg-fuchsia-100 dark:bg-fuchsia-900/30 text-fuchsia-600 dark:text-fuchsia-300',
        pink: 'bg-pink-100 dark:bg-pink-900/30 text-pink-600 dark:text-pink-300',
        rose: 'bg-rose-100 dark:bg-rose-900/30 text-rose-600 dark:text-rose-300'
      }[color] ||
      'bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-300'
    );
  };

  return (
    <div
      className={clsx(
        'inline-block rounded-full px-4 py-1 text-sm',
        getColorClasses(color),
        className
      )}
    >
      {children}
    </div>
  );
}
